import React from 'react';

interface MapPopupProps {
  children: React.ReactNode;
}

export default function MapPopup({ children }: MapPopupProps) {
  return <div className='rounded-2 bg-white px-3 py-2 font-[Inter] text-sm shadow-default'>{children}</div>;
}
